import type { QuestionVisibilityState } from "@/components/survey/Question";
import { DiabetesTypeOptionId } from "@/constants/survey-answers";
import { ExperimentAssignments } from "@/models/experiments";

import { isBVSDPartner } from "../partners";

export enum ScaleEligibility {
  OPT_IN,
  NOOMCOIN,
  NONE,
}

function getBVSDScaleEligibility(
  state: QuestionVisibilityState,
  experiments: ExperimentAssignments,
): ScaleEligibility {
  const { qualifiedPrograms, surveyAnswers } = state;
  // BVSD users who are in DM should be able to just order a scale
  if (qualifiedPrograms.includes("DIABETES_LIFESTYLE")) {
    return ScaleEligibility.OPT_IN;
  }
  // BVSD users who have Type 2 are not part of the experiment
  if (
    surveyAnswers.diabetesType === DiabetesTypeOptionId.TYPE2 ||
    surveyAnswers.diabetesType === DiabetesTypeOptionId.UNSURE
  ) {
    return ScaleEligibility.NONE;
  }
  return experiments["scale-earning-opt-in"] === "variant"
    ? ScaleEligibility.NOOMCOIN
    : ScaleEligibility.NONE;
}

export const determineScaleEligibility = (
  state: QuestionVisibilityState,
): ScaleEligibility => {
  const { experiments, eligibilityInfo, partnerInfo, selectedProgram } = state;

  if (selectedProgram === "MOOD") {
    return ScaleEligibility.NONE;
  }

  if (selectedProgram === "MED" || selectedProgram === "NMPBA") {
    return ScaleEligibility.OPT_IN;
  }

  // legacy behavior for BVSD users
  if (isBVSDPartner(partnerInfo)) {
    return getBVSDScaleEligibility(state, experiments);
  }

  switch (eligibilityInfo?.scaleEligible) {
    case "FREE_SCALE":
    case "INCLUDED_SCALE":
      return ScaleEligibility.OPT_IN;
    case "NOOMCOIN":
      return ScaleEligibility.NOOMCOIN;
    case "MED_ONLY":
      return ScaleEligibility.NONE;
    default:
      return ScaleEligibility.NONE;
  }
};
